import * as React from "react";
import "./style.scss";
import { AxisLabel, AxisTick, Legend as LegendContents } from "../../common";
import { Tooltip as TooltipContents } from "../../../common/Tooltip";
import {
  Dot as reDot,
  LineChart,
  Line as reLine,
  Brush as reBrush,
  XAxis,
  YAxis,
  CartesianGrid,
  CartesianAxis,
  Tooltip as reTooltip,
  Text,
  ResponsiveContainer,
  Legend
} from "recharts";
import * as utils from "../../../common";
import _ from "lodash";

const Tooltip: any = reTooltip;

//WORKAROUND rechart type definitions
const Brush: any = reBrush;
const Dot: any = reDot;
const Line: any = reLine;
export class SimpleLineChart extends React.Component<
  SimpleLineChartProps,
  any
> {
  renderLines() {
    if (this.props.chartProps != null && this.props.chartProps.data != null) {
      let stackId = this.props.chartProps.stacked ? "a" : null;
      let valueKeys: string[] = [];
      let lines: any = [];

      this.props.chartProps.data.forEach((entry: any) => {
        valueKeys.push(
          ...Object.keys(entry).filter(
            (key: string) =>
              key.toLowerCase() !=
              this.props.chartProps.groupingKey.toLowerCase()
          )
        );
      });
      valueKeys = _.uniq(valueKeys);
      valueKeys.forEach((key, index) => {
        lines.push(
          <Line
            type="monotone"
            key={index}
            dataKey={key}
            stroke={`#${utils.CHART_COLORS[index % utils.CHART_COLORS.length].toString(16)}`}
            strokeWidth={2}
            dot={false}
          />
        );
      }, this);

      return lines;
    }
  }

  renderTooltip() {
    let {
      chartProps: { data, valueKey, groupingKey }
    } = this.props;
    return (
      <Tooltip
        content={
          <TooltipContents
            valueKey={valueKey}
            groupingKey={groupingKey}
            filterNull={false}
          />
        }
      />
    );
  }

  render() {
    //NOTE: the order of child components matter, render items on top last
    const {
      xAxisProps: { tickProps: xTickProps, labelProps: xLabelProps },
      yAxisProps: { tickProps: yTickProps, labelProps: yLabelProps },
      chartProps: { data, groupingKey },
      initialZoom
    } = this.props;
    if (!data || data.length == 0) {
      return <div />;
    } else {
      let lines = this.renderLines();

      return (
        <div className="line-chart" style={{ width: "100%", height: "100%" }}>
          <ResponsiveContainer {...this.props.containerProps}>
            <LineChart
              {...this.props.chartProps}
              margin={{
                top: lines.length > 1 ? 40 : 20,
                right: 30,
                left: 0,
                bottom: 5
              }}
            >
              <XAxis
                height={70}
                label={<AxisLabel {...xLabelProps} />}
                tick={<AxisTick {...xTickProps} />}
                dataKey={this.props.chartProps.groupingKey}
              />
              <YAxis
                type="number"
                allowDecimals={true}
                interval={"preserveStart"}
                domain={[0, "auto"]}
                label={<AxisLabel {...yLabelProps} />}
                tickLine={false}
                tick={<AxisTick {...yTickProps} />}
                axisLine={false}
                width={70}
              />
              <CartesianGrid vertical={false} strokeDasharray="3 3" />
              {this.renderTooltip()}
              {lines}
              {lines.length > 1 ? (
                <Legend
                  verticalAlign="top"
                  align="center"
                  wrapperStyle={{ top: 10 }}
                  content={
                    <LegendContents
                      compareKey={this.props.chartProps.compareKey}
                    />
                  }
                />
              ) : null}
              <Brush
                fill="#F5F7FB"
                stroke="#C4CCE3"
                dataKey={this.props.chartProps.groupingKey}
                data={this.props.chartProps.data}
                startIndex={initialZoom ? initialZoom.startIndex : null}
                endIndex={initialZoom ? initialZoom.endIndex : null}
                onChange={this.props.onBrushChange}
              >
                <LineChart>
                  <Text textAnchor="start" verticalAnchor="start">
                    DRAG TO ZOOM
                  </Text>
                  {this.renderLines()}
                </LineChart>
              </Brush>
            </LineChart>
          </ResponsiveContainer>
        </div>
      );
    }
  }
}

class CustomDot extends React.Component<any, any> {
  //TODO: RR style dot
  render() {
    const { cx, cy, stroke, payload, value } = this.props;
    return (
      <svg className="custom-dot" height="10" width="10">
        <circle
          cx={cx}
          cy={cy}
          r="2"
          stroke={stroke}
          strokeWidth="3"
          fill={stroke}
          viewBox="0 0 1024 1024"
        />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Chart/CartesianChart/LineChart/SimpleLineChart/index.tsx